/* AESKA clean header: open the header search from the search icons, close it on X, Escape or a click outside. */
(() => {
  if (window.__aeskaHeaderBound) return;
  window.__aeskaHeaderBound = true;

  const body = document.body;
  const CLASS = 'aeska-search-shown';
  const isOpen = () => body.classList.contains(CLASS);

  const open = () => {
    body.classList.add(CLASS);
    const input = document.querySelector('.aeska-hdr .header__search input[type="search"]');
    if (input) setTimeout(() => input.focus(), 60);
  };

  const close = () => {
    body.classList.remove(CLASS);
    body.classList.remove('search-open');
    const search = document.querySelector('.aeska-hdr predictive-search');
    if (search) search.classList.remove('predictive-search-open');
    if (document.activeElement && document.activeElement.closest('.aeska-hdr .header__search')) {
      document.activeElement.blur();
    }
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-aeska-search-open]')) {
      event.preventDefault();
      if (isOpen()) close();
      else open();
      return;
    }
    if (!isOpen()) return;
    if (event.target.closest('.aeska-hdr .header__search-close')) {
      close();
      return;
    }
    if (!event.target.closest('.aeska-hdr .header__search')) close();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isOpen()) close();
  });

  document.addEventListener('menu-drawer:open', close);
})();
